import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './components/i18n.js';
import UserAuthentication from './pages/UserAuthentication.jsx';
import Booking from './pages/Booking/Booking.jsx';
import PaymentSuccess from "./pages/PaymentSuccess.jsx";
import UpcomingJourney from "./pages/UpcomingJourney.jsx";
import TransactionDetails from "./pages/TransactionDetails.jsx"
import PaymentFailed from "./pages/PaymentFailed.jsx";
import PrivateRoute from "./pages/PrivateRoute.jsx";
import './style.scss';
import FAQ from "./pages/FAQ.jsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: <UserAuthentication />,
  },
  {
    path: "/booking",
    element: (
      <PrivateRoute>
        <Booking />
      </PrivateRoute>
    ),
  },
  {
    path: "/journey",
    element: (
      <PrivateRoute>
        <UpcomingJourney />
      </PrivateRoute>
    ),
  },
  {
    path: "/transaction-details",
    element: (
      <PrivateRoute>
        <TransactionDetails />
      </PrivateRoute>
    ),
  },
  {
    path: "/payment-failure",
    element: <PaymentFailed />,
  },
  {
    path: "/payment-success",
    element: <PaymentSuccess />,
  },  
  {
    path: "/faq",
    element: <FAQ />,
  }
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

